import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import React from "react";

function DFMenuItem({ onClick, icon, text, ...props }) {
  return (
    <MenuItem onClick={onClick}>
      {icon && <ListItemIcon>{icon}</ListItemIcon>}

      <ListItemText primary={text} />
    </MenuItem>
  );
}

export default DFMenuItem;
